<div class="gt-routes-list-containerss ">
    <dx-data-grid id="gridContainer" #dashboardConfigGrid [dataSource]="dashboardConfig" [remoteOperations]="false"
        class="gt-padding-medium" [allowColumnReordering]="true" [rowAlternationEnabled]="true" [showBorders]="true"
        [paging]="false" [allowColumnResizing]="true" [columnResizingMode]="'widget'" [columnAutoWidth]="false"
        [showBorders]="true" [scrolling]="{ mode: 'standard', useNative: true }" [width]="'100%'"
        class="gt-data-grid-style" [hoverStateEnabled]="true">

        <dxo-toolbar>

            <dxi-item location="before">
                <div *dxTemplate>
                    <dx-button i18n-text="@@all" text="ALL" (onClick)="removeFilters($event)"></dx-button>
                </div>
            </dxi-item>
            <dxi-item location="before">
                <div *dxTemplate>
                    <dx-button i18n-text="peCaps" text="PE" (onClick)="filterPe($event)"></dx-button>
                </div>
            </dxi-item>
            <dxi-item location="before">
                <div *dxTemplate>
                    <dx-button i18n-text="paCaps" text="PA" (onClick)="filterPa($event)"></dx-button>
                </div>
            </dxi-item>
            <!--         
            
        <dxi-item>
            <div *dxTemplate>
                <dx-button icon="plus" (onClick)="addNewRow($event)"></dx-button>
            </div>
        </dxi-item>

        <dxi-item>
            <div *dxTemplate>
                <dx-button icon="save" (onClick)="saveChanges($event)"></dx-button>
            </div>
        </dxi-item> -->
        </dxo-toolbar>

        <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
        <dxi-column dataField="title" i18n-caption="@@title" caption="Title"></dxi-column>
        <dxi-column dataField="type" i18n-caption="@@type" caption="Type">
            <dxo-lookup [dataSource]="types" displayExpr="title" valueExpr="value"></dxo-lookup>
        </dxi-column>
        <dxi-column dataField="condition" i18n-caption="@@condition" caption="Condition"></dxi-column>
        <dxi-column dataField="value" i18n-caption="@@value" caption="Value"></dxi-column>
        <dxi-column dataField="pe" i18n-caption="@@peCaps" caption="PE" width="30"></dxi-column>
        <dxi-column dataField="pa" i18n-caption="@@paCaps" caption="PA" width="30"></dxi-column>
        <dxi-column dataField="none" cellTemplate="deleteCellTemplate" width="47" [allowEditing]="false">
            <div *dxTemplate="let item of 'deleteCellTemplate'">
                <dx-button class="button-clear" (onClick)="deleteItem($event, item)">
                    <i class="dx-icon-clear"></i>
                </dx-button>
            </div>
        </dxi-column>
    </dx-data-grid>

    <div class="gt-bottom-page-button-container">
        <div class="gt-flex-width">

        </div>
        <div class="gt-flex-dir-row-rev">
            <dx-button (onClick)="saveChanges($event)" i18n-text="@@saveCaps" text="SAVE"
                class="gt-button gt-primary gt-bottom gt-btn-right"></dx-button>

            <dx-button (onClick)="addNewRow($event)" i18n-text="@@addCaps" text="ADD"
                class="gt-button gt-primary gt-bottom gt-btn-right"></dx-button>

        </div>
    </div>
</div>
<dx-toast [visible]="toastVisible" [type]="type" message="{{message}}" position="bottom center" width="fit-content">
</dx-toast>